import axios from 'axios';
import {baseUrlAsync} from "../../utils/api";
import API from "../../utils/api";

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getAiSettingsApi = async () => {
    const response = await API.get(`ai-settings`);
    return { response };
};

export const getAiSettingApi = async (feature) => {
    try {
        const res = await axios.get(`${baseUrlAsync}/ai-settings/${feature}`, {
            headers: getAuthHeaders(),
            validateStatus: (status) => status < 500,
        });
        if (res.status === 404) {
            return { response: null };
        }
        return { response: res.data };
    } catch (e) {
        return { response: null };
    }
};

export const saveAiSettingApi = async (feature, data) => {
    const response = await API.post(`ai-settings/${feature}`, data);
    return { response };
};

export const getGenerateImageOptionsApi = async () => {
    try {
        const res = await axios.get(`${baseUrlAsync}/ai-settings/generate-image-options`, {
            headers: getAuthHeaders(),
            validateStatus: (status) => status < 500,
        });
        if (res.status === 404) {
            return { response: { shot_types: [], aspect_ratios: [] } };
        }
        return { response: res.data };
    } catch (e) {
        return { response: { shot_types: [], aspect_ratios: [] } };
    }
};
